export default __webpack_public_path__ + "images/something-went-offscript.ebdd19e21f3d05387e8c11e881993bff.jpg";